module.exports = __webpack_public_path__ + "img/icon_exchange_info.cacd5078.png";